import Vue from 'vue';
import Vuex from 'vuex';
import nodes from './modules/nodes';
import black from './modules/black';
import global from './modules/global';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    nodes,
    black,
    global,
  },
});
